import React, { useState, useImperativeHandle, forwardRef } from "react";

import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

const ParochosFormModal = forwardRef((props, ref) => {

    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();



    useImperativeHandle(ref, () => ({

        open() {
            setShowModal(true)
        },
        close() {
            setShowModal(false)
        },

    }));
    const handleCloseModal = (e) => {
        e.preventDefault();
        setShowModal(false);
    }


    return (
        <form id="parochos_modal_form" autoComplete="off" >

            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showModal}
                backdrop="static"
                keyboard={false}
                scrollable={true}

            >
                <Modal.Header >
                    <Modal.Title>
                        <h3 className="text-center">{t("parochosModalFormHeaderMess")}</h3>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="alert alert-danger small-info" role="alert">
                            {t("parochosModalFormBody1")}
                        </div>

                        <div className="text-center">
                            <a href="#" onClick={() => {
                                navigate("/parochosform");
                                setShowModal(false);
                            }}>{t("completeFormHere")}</a>
                        </div>
                        <br></br>
                        <div className="alert alert-danger small-info" role="alert">
                            {t("parochosModalFormBody2")}
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-skin" onClick={handleCloseModal}>{t("cancel")}</button>
                </Modal.Footer>

            </Modal>
        </form>

    );
}
);

export default ParochosFormModal;
